var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('info'),_c('el-row',{staticClass:"mt10",attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":12}},[_c('meet')],1),_c('el-col',{attrs:{"span":12}},[_c('help')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }